var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89583 0.125C8.69157 0.125 10.4138 0.838353 11.6835 2.10813C12.9533 3.37791 13.6667 5.1001 13.6667 6.89583C13.6667 8.57292 13.0521 10.1146 12.0417 11.3021L12.3229 11.5833H13.1458L18.3542 16.7917L16.7917 18.3542L11.5833 13.1458V12.3229L11.3021 12.0417C10.1146 13.0521 8.57292 13.6667 6.89583 13.6667C5.1001 13.6667 3.37791 12.9533 2.10813 11.6835C0.838353 10.4138 0.125 8.69157 0.125 6.89583C0.125 5.1001 0.838353 3.37791 2.10813 2.10813C3.37791 0.838353 5.1001 0.125 6.89583 0.125ZM6.89583 2.20833C4.29167 2.20833 2.20833 4.29167 2.20833 6.89583C2.20833 9.5 4.29167 11.5833 6.89583 11.5833C9.5 11.5833 11.5833 9.5 11.5833 6.89583C11.5833 4.29167 9.5 2.20833 6.89583 2.20833Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.3af88754.svg";
export { ForwardRef as ReactComponent };